import { createContext, useCallback, useContext, useMemo, useState } from 'react';
import { TURN_PHASES } from '../hooks/useWSTurnState';

const DebugPhaseContext = createContext();

export function DebugPhaseProvider({ children }) {
  const [debugPhase, setDebugPhase] = useState(TURN_PHASES.SelfIntroductions);

  const setDebugPhaseStable = useCallback((phase) => setDebugPhase(phase), []);

  const value = useMemo(() => ({
    debugPhase,
    setDebugPhase: setDebugPhaseStable,
  }), [debugPhase, setDebugPhaseStable]);

  return (
    <DebugPhaseContext.Provider value={value}>
      {children}
    </DebugPhaseContext.Provider>
  );
}

export function useDebugPhase() {
  const context = useContext(DebugPhaseContext);
  if (!context) {
    throw new Error('useDebugPhase deve ser usado dentro de DebugPhaseProvider');
  }
  return context;
}
